import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {

	getLock(lockID) {

		return axios.get(
			API.url(Endpoints.Hardware.GetLock, {lock_id: lockID})
		).then((res) => {
			return res.data.lock;
		});

	},

	enableTagRegistration(lockID) {

		return axios.post(
			API.url(Endpoints.Hardware.EnableTagRegisration, {lock_id: lockID}),
            {}
		).then((res) => {
			return res.data;
		});

	},

	getIQNetworkDetails(iqID) {

		return axios.get(
			API.url(Endpoints.Hardware.GetIQNetworkDetails, {iq_id: iqID})
		).then((res) => {
			return res.data.iq_network_details;
		});

	},

	getNumLocksWithLowBattery(centreID) {

		return axios.get(
			API.url(Endpoints.Hardware.GetLocksWithLowBattery) + "?centre_id=" + centreID
		).then((res) => {
			return res.data;
		});

	}

}
